import React from "react";
import { SharedCertificateForm } from "./SharedCertificateForm";
interface AddCertificatePageProps {
    spaceId: string;
}
export function AddCertificatePage({ spaceId }: AddCertificatePageProps) {
    return <SharedCertificateForm spaceId={spaceId} create={true}/>;
}
